module.exports = __webpack_public_path__ + "static/media/img1.543af9df.jpg";